import { render, staticRenderFns } from "./websocket.vue?vue&type=template&id=51477831&scoped=true"
import script from "./websocket.vue?vue&type=script&lang=js"
export * from "./websocket.vue?vue&type=script&lang=js"
import style0 from "./websocket.vue?vue&type=style&index=0&id=51477831&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51477831",
  null
  
)

export default component.exports